import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'

const CheckBox = ({
    label,
    checked,
    onChange = () => {}
}) => (
    <Row><Col>
        <Form.Check inline type='checkbox' label={label} checked={!!checked} onChange={e => onChange(Boolean(e.target.checked))} />
    </Col></Row>
)

export default CheckBox